import 'firebase/compat/auth';
import allcompanyconfig from './../companyconfig.json';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import store from 'state/store/store';
import { LogOut } from 'state/actions/actions';

function createFirebaseApp() {
  const firebaseConfig = allcompanyconfig.firebaseConfig;
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    // if already initialized, use that one
    firebase.app();
  }
}

export default createFirebaseApp;

export function safePostCall(endpoint = '', data = {}, config = {}) {
  let user = firebase.auth().currentUser;
  if (user) {
    return user
      .getIdToken()
      .then(idToken => {
        return axios.post(endpoint, data, {
          ...config,
          headers: {
            ...config?.headers,
            authorization: `auth ${idToken}`,
            token: `auth ${idToken}`
          }
        });
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}

export function postApiCall(endpoint = '', data = {}, config = {}) {
  return axios.post(endpoint, data, {
    ...config,
    headers: {
      ...config?.headers
    }
  });
}

export function safeAWSCallGet(route = '', parameters = {}, testing = false) {
  let user = firebase.auth().currentUser;
  if (user) {
    if (testing) {
      const objToUrlParams = someObj =>
        `?${Object.keys(someObj)
          .map(key => `${key}=${someObj[key]}`)
          .join('&')}`;
      return user
        .getIdToken()
        .then(idToken => {
          return axios({
            method: 'GET',
            url: `http://localhost:3000${route}${objToUrlParams(parameters)}`,
            data: parameters,
            headers: {
              authorization: `auth ${idToken}`
            }
          });
        })
        .catch(error => {
          console.error(error);
          return null;
        });
    }
    return user
      .getIdToken()
      .then(idToken => {
        // reject here so a missing token lands in the .catch below instead of sending a bad header
        if (!idToken) throw new Error('Missing Firebase ID token');
        const headers = { authorization: `token ${idToken}` };
        const paramsForUrl = `?${Object.keys(parameters)
          .map(paramKey => `${paramKey}=${parameters[paramKey]}`)
          .join('&')}`;
        return axios({
          method: 'GET',
          url: `${allcompanyconfig.firebaseConfig.awsApiBaseUrl}${route}${paramsForUrl}`,
          headers: headers
        });
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}

export function safeAWSCallGetBlob(
  route = '',
  parameters = {},
  testing = false
) {
  let user = firebase.auth().currentUser;
  if (user) {
    if (testing) {
      const objToUrlParams = someObj =>
        `?${Object.keys(someObj)
          .map(key => `${key}=${someObj[key]}`)
          .join('&')}`;
      return user
        .getIdToken()
        .then(idToken => {
          return axios({
            method: 'GET',
            url: `http://localhost:3000${route}${objToUrlParams(parameters)}`,
            data: parameters,
            headers: {
              authorization: `auth ${idToken}`
            },
            responseType: 'blob'
          });
        })
        .catch(error => {
          console.error(error);
          return null;
        });
    }
    return user
      .getIdToken()
      .then(idToken => {
        // reject here so a missing token lands in the .catch below instead of sending a bad header
        if (!idToken) throw new Error('Missing Firebase ID token');
        const headers = { authorization: `token ${idToken}` };
        const paramsForUrl = `?${Object.keys(parameters)
          .map(paramKey => `${paramKey}=${parameters[paramKey]}`)
          .join('&')}`;
        return axios({
          method: 'GET',
          url: `${allcompanyconfig.firebaseConfig.awsApiBaseUrl}${route}${paramsForUrl}`,
          headers: headers,
          responseType: 'blob'
        });
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}

export function safeAWSCallPost(
  route = '',
  parameters = {},
  testing = false,
  config = {}
) {
  let user = firebase.auth().currentUser;
  if (user) {
    if (testing) {
      return user
        .getIdToken()
        .then(idToken => {
          return axios({
            method: 'POST',
            url: `http://localhost:3000${route}`,
            data: parameters,
            ...config,
            headers: {
              authorization: `auth ${idToken}`,
              ...config?.headers
            }
          });
        })
        .catch(error => {
          console.error(error);
          return null;
        });
    }
    return user
      .getIdToken()
      .then(idToken => {
        // reject here so a missing token lands in the .catch below instead of sending a bad header
        if (!idToken) throw new Error('Missing Firebase ID token');
        const headers = { authorization: `token ${idToken}` };
        return axios({
          method: 'POST',
          url: `${allcompanyconfig.firebaseConfig.awsApiBaseUrl}${route}`,
          data: parameters,
          ...config,
          headers: {
            ...headers,
            ...config?.headers
          }
        });
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}

export function safeAWSCallPostBlob(
  route = '',
  parameters = {},
  testing = false
) {
  let user = firebase.auth().currentUser;
  if (user) {
    if (testing) {
      return user
        .getIdToken()
        .then(idToken => {
          return axios({
            method: 'POST',
            url: `http://localhost:3000${route}`,
            data: parameters,
            headers: {
              authorization: `auth ${idToken}`
            },
            responseType: 'blob'
          });
        })
        .catch(error => {
          console.error(error);
          return null;
        });
    }
    return user
      .getIdToken()
      .then(idToken => {
        // reject here so a missing token lands in the .catch below instead of sending a bad header
        if (!idToken) throw new Error('Missing Firebase ID token');
        const headers = { authorization: `token ${idToken}` };
        return axios({
          method: 'POST',
          url: `${allcompanyconfig.firebaseConfig.awsApiBaseUrl}${route}`,
          data: parameters,
          headers: headers,
          responseType: 'blob'
        });
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}

export function safeAWSCallPostStream(route = '', parameters = {}) {
  let user = firebase.auth().currentUser;
  if (user) {
    return user
      .getIdToken()
      .then(idToken => {
        // reject here so a missing token lands in the .catch below instead of sending a bad header
        if (!idToken) throw new Error('Missing Firebase ID token');
        const headers = { authorization: `token ${idToken}` };
        return fetch(
          `${allcompanyconfig.firebaseConfig.awsApiBaseUrl}${route}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              ...headers
            },
            body: JSON.stringify(parameters)
          }
        );
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}

export function safeAWSCallPatch(route = '', parameters = {}, testing = false) {
  let user = firebase.auth().currentUser;
  if (user) {
    if (testing) {
      return user
        .getIdToken()
        .then(idToken => {
          return axios({
            method: 'PATCH',
            url: `http://localhost:3000${route}`,
            data: parameters,
            headers: {
              authorization: `auth ${idToken}`
            }
          });
        })
        .catch(error => {
          console.error(error);
          return null;
        });
    }
    return user
      .getIdToken()
      .then(idToken => {
        // reject here so a missing token lands in the .catch below instead of sending a bad header
        if (!idToken) throw new Error('Missing Firebase ID token');
        const headers = { authorization: `token ${idToken}` };
        return axios({
          method: 'PATCH',
          url: `${allcompanyconfig.firebaseConfig.awsApiBaseUrl}${route}`,
          data: parameters,
          headers: headers
        });
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}

export function safeAWSCallDelete(
  route = '',
  parameters = {},
  testing = false
) {
  let user = firebase.auth().currentUser;
  if (user) {
    if (testing) {
      return user
        .getIdToken()
        .then(idToken => {
          return axios({
            method: 'DELETE',
            url: `http://localhost:3000${route}`,
            data: parameters,
            headers: {
              authorization: `auth ${idToken}`
            }
          });
        })
        .catch(error => {
          console.error(error);
          return null;
        });
    }
    return user
      .getIdToken()
      .then(idToken => {
        // reject here so a missing token lands in the .catch below instead of sending a bad header
        if (!idToken) throw new Error('Missing Firebase ID token');
        const headers = { authorization: `token ${idToken}` };
        return axios({
          method: 'DELETE',
          url: `${allcompanyconfig.firebaseConfig.awsApiBaseUrl}${route}`,
          data: parameters,
          headers: headers
        });
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  } else {
    store.dispatch(LogOut());
    return Promise.resolve({
      data: {
        details: {
          output: ''
        }
      }
    });
  }
}
